module.exports = __webpack_public_path__ + "static/media/ios-3.2a3b9c9b.jpg";